import { atomWithStorage } from "jotai/utils";
export const MAGIC_ATOM = atomWithStorage("magic-key", false);
